module.exports = __webpack_public_path__ + "static/media/014.d9cba34c.jpg";